import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} fill='none' {...props}>
    <rect width={40} height={40} fill='#FF9800' rx={8} />
    <g stroke='#fff' strokeLinejoin='round' strokeWidth={1.5} clipPath='url(#gold-icon_svg__a)'>
      <path d='M19.12 28.91h-8.28a.83.83 0 0 1-.82-1l.76-3.76a.84.84 0 0 1 .82-.67h6.76a.84.84 0 0 1 .82.67l.76 3.76a.83.83 0 0 1-.82 1ZM29.16 28.91h-8.28a.83.83 0 0 1-.82-1l.76-3.76a.84.84 0 0 1 .82-.67h6.76a.84.84 0 0 1 .82.67l.76 3.76a.83.83 0 0 1-.82 1Z' />
      <path d='M24.14 23.49h-8.28a.83.83 0 0 1-.82-1l.76-3.76a.84.84 0 0 1 .82-.67h6.76a.84.84 0 0 1 .82.67l.76 3.76a.83.83 0 0 1-.82 1Z' />
      <path strokeLinecap='round' d='M20 13.88v-2.84M23.14 15.04l2.43-1.4M14.43 13.67l2.42 1.4' />
    </g>
    <defs>
      <clipPath id='gold-icon_svg__a'>
        <path fill='#fff' d='M8 8h24v24H8z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGoldIcon;
